import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { ValidatorComponent } from "react-material-ui-form-validator";
import { CheckboxChecked, CheckboxIcon } from "../../assets/images/icons";

class CheckboxValidatorElement extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      handleAccept,
      checked,
      errorMessages,
      validators,
      validatorListener,
      requiredError,
      value,
      name,
      ...rest
    } = this.props;
    const { isValid } = this.state;

    return (
      <>
        <FormControlLabel
          {...rest}
          className={!isValid ? "Mui-error" : ""}
          control={
            <Checkbox
              icon={<CheckboxIcon />}
              checkedIcon={<CheckboxChecked />}
              name={name}
              checked={checked}
              onChange={handleAccept}
            />
          }
        />
      </>
    );
  }
}

export default CheckboxValidatorElement;
